import React from "react";
import { useContent } from "../../../contexts/contentContext/contentContext.js";
import Icon from "../../Elements/Icon/Icon.tsx";
import SingleLineForm from "../../Reusable/SingleLineForm/SingleLineForm.js";
import apiRequest from "../../../utils/ApiRequest/apiRequest.js";
import { LinkToNewTab } from "../../Elements/Link/Link.js";

export const NewsletterSection = () => {
  const { getTextByKey } = useContent();

  const signUpForNewsLetter = async (email, recaptchaResponse) => {
    const body = {
      email: email,
      recaptchaResponse: recaptchaResponse,
    };
    const response = await apiRequest(
      "MailingLists",
      `ClientSubscribe`,
      body,
      "POST"
    );
    return {
      message:
        response.status === "success"
          ? getTextByKey("join-newsletter-success-message")
          : getTextByKey("join-newsletter-invalid-mail-message"),
      status: response.status,
    };
  };
  return (
    <div className="footer-join-newsletter">
      <div className="footer-section-title">
        {getTextByKey("follow-us-on-social-media")}
      </div>
      {/* <SingleLineForm
        iconName={"arrow-right"}
        placeholder={"join-newsletter-placeholder"}
        onSubmit={signUpForNewsLetter}
      /> */}
      <div className="social-media-icons-container">
        <LinkToNewTab
          fullUrl={true}
          page="https://www.facebook.com/jumbomail.me"
          isNewTab={true}
          ariaLabel={"facebook"}
        >
          <Icon name="facebook" white xl />
        </LinkToNewTab>
        <LinkToNewTab
          fullUrl={true}
          page="https://www.x.com/jumbomail_me"
          isNewTab={true}
          ariaLabel={"x"}
        >
          <Icon name="x-twitter" white xl />
        </LinkToNewTab>
        <LinkToNewTab
          fullUrl={true}
          page="https://www.instagram.com/jumbo.mail.me"
          isNewTab={true}
          ariaLabel={"instagram"}
        >
          <Icon name="instagram" white xl />
        </LinkToNewTab>
        <LinkToNewTab
          fullUrl={true}
          page="https://www.linkedin.com/company/jumbomail"
          isNewTab={true}
          ariaLabel={"instagram"}
        >
          <Icon name="linkedin" white xl />
        </LinkToNewTab>
      </div>

      <iframe
        title="facebook-like-button"
        src="https://www.facebook.com/plugins/like.php?href=https%3A%2F%2Fdevelopers.facebook.com%2Fdocs%2Fplugins%2F&locale=en_US&width=62&layout=button&action=like&size=small&share=false&height=65&appId=858271961933333"
        width="62"
        height="65"
        scrolling="no"
        frameBorder="0"
        allow="encrypted-media"
      ></iframe>
    </div>
  );
};
